module.exports = __webpack_public_path__ + "img/lists.d92c242a.svg";